/**
 * schoolsApi.js
 * -------------
 * API client for School / College Master using createMasterApiClient.
 * Connects directly to FastAPI backend /schools/ endpoints.
 * Exports are processed asynchronously via JobEngine background jobs (useExportJob).
 */
import { createMasterApiClient } from '../../common/masterApiFactory';

export const schoolsClient = createMasterApiClient('schools');

export async function listSchools(params = {}) {
  return await schoolsClient.list(params);
}

export async function getSchoolDetail(schoolId) {
  return await schoolsClient.getById(schoolId);
}

export async function createSchool(payload) {
  return await schoolsClient.create(payload);
}

export async function updateSchool(schoolId, payload) {
  return await schoolsClient.update(schoolId, payload);
}

export async function archiveSchool(schoolId) {
  return await schoolsClient.archive(schoolId);
}

export async function deleteSchool(schoolId) {
  return await schoolsClient.remove(schoolId);
}

export async function getSchoolOptions() {
  return await schoolsClient.getDropdownOptions();
}
